<template>
  <div>
    <form @submit.prevent="submitChanges">
    <div class="panel-heading" style="display: flex; align-items: center; justify-content: space-between;">
      <h4 class="panel-title" style="margin: 0;">Order Types</h4>
      <div class="col-md-12">
        <div class="col-md-6"></div>
        <div class="col-md-6 text-right">
          <v-btn
          v-if="$_has_perm('add_order_type')"
          style="height: auto"
          depressed
          @click="openAddOrderTypeModal"
        >
          <v-icon
            icon
            style="color: #006b8d"
            class="fa fa-plus fa-lg mr-2"
          > </v-icon>
          Add New Order Type
        </v-btn>
        </div>
      </div>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <div class="col-xs-12">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>ID</th>
                <th>Order Type Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in apiResults" :key="item.id || idx">
                <td>{{ item.order_type_id }}</td>
                <td>{{ item.type_name }}</td>
                <td>
                  <a
                    v-if="$_has_perm('edit_order_type')"
                    style="color: #085AB2FF"
                    tooltip="Edit Order Type"
                    @click="editRecord(item, idx)"
                  >
                    <i class="material-icons">edit</i>
                  </a>
                  <a
                    v-if="$_has_perm('delete_order_type')"
                    style="color: #B22708FF"
                    tooltip="Delete Order Type"
                    @click="deleteRecord(item, idx)"
                  >
                    <i class="material-icons">delete</i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </form>

    <create-order-type
      :addOrderTypeModal="addOrderTypeModal"
      :closeAddOrderTypeModal="closeAddOrderTypeModal"
      :submitOrderType="submitOrderType"
      :addEditData="addEditData"
      ></create-order-type>

  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import addEditOrderType from './addEditOrderType.vue'

export default {
  components: {
    'create-order-type': addEditOrderType
  },
  mounted() {
    this.getResults()
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      loading: false,
      addOrderTypeModal: false,
      url: 'api/order-types',
      apiResults: [],
      warehouses: [],
      subscriptions: [],
      addEditData: {
        type_name: ''
      }
    }
  },

  methods: {

    getResults(url = this.url) {
      let token = localStorage.getItem('access_token')

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          this.apiResults = data.data
        })
    },

    openAddOrderTypeModal() {
      this.addOrderTypeModal = true
    },

    closeAddOrderTypeModal() {
      this.addOrderTypeModal = false
      this.clear()
    },

    clear() {
      this.addEditData = {
        type_name: ''
      }
      this.addOrderTypeModal = false
      this.$validator.reset()
    },

    submitOrderType() {
      let token = localStorage.getItem('access_token')

      // Check if we're editing (has order_type_id) or adding new
      const isEditing = this.addEditData.order_type_id
      const method = isEditing ? 'patch' : 'post'
      const url = isEditing ? `${this.url}/${this.addEditData.order_type_id}` : this.url

      axios[method](url, this.addEditData, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.validationError = false
          this.checkAlert = true
          this.getResults()
          this.clear()
        })
        .catch(error => {
          if (error.response.data.message) {
            this.checkAlert = false
            this.validationError = true
          }
        })
    },

    editRecord(item, idx) {
      console.log(item)
      this.addEditData = {
        ...item,
        order_type_id: item.order_type_id
      }
      this.addOrderTypeModal = true
    },

    deleteRecord(item, idx) {
      swal({
        title: 'Are you sure?',
        text: `Delete Order Type: ${item.type_name}?`,
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .delete(this.url + '/' + item.order_type_id, { headers: { Authorization: 'Bearer ' + token } })
            .then(response => {
              this.getResults()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch(error => {
              if (error.response) {
                swal('Error', `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    }
  }
}
</script>

<style>

/* Make the table dense */
.table.table-bordered th,
.table.table-bordered td {
  padding: 2px 4px !important;
  font-size: 13px !important;
  vertical-align: middle !important;
}

.table.table-bordered input.form-control {
  height: 20px !important;
  padding: 2px 6px !important;
  font-size: 13px !important;
}

.table.table-bordered {
  margin-bottom: 0;
}

.btn.btn-sm, .btn.btn-danger.btn-sm {
  padding: 2px 8px !important;
  font-size: 12px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/orderType/orderTypes.vue